import {useTranslation} from "react-i18next";
import Grid from "@material-ui/core/Grid";
import React from "react";
import {ExternalPublicPackageDTO, ExternalPublicTrackingDTO} from "../../constants/ParcelContants";
import {
    Link,
    Paper,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Typography
} from "@material-ui/core";
import {Public} from "@material-ui/icons";
import ParcelTrackingInfoCard from "./ParcelTrackingInfoCard";

const ParcelResultsComponents: React.FC<{ parcel: ExternalPublicTrackingDTO }> = ({parcel}) => {
    const {t} = useTranslation();
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };

    const currentPackage: ExternalPublicPackageDTO | undefined = parcel.packages && parcel.packages[value];
    return (<>
        <Grid item xs={12}>
            <ParcelTrackingInfoCard parcel={parcel}/>
        </Grid>

        <Grid item xs={12}>

            <Paper square>
                <Tabs
                    value={value}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleChange}
                >
                    {parcel.packages?.map((pck, index) => {
                        return (<Tab key={index} label={pck.licensePlate}/>)
                    })}
                </Tabs>

                <div style={{display: "flex", justifyContent: "flex-end"}}>
                    <Typography>
                        <Link style={{display: "flex", alignItems: "center"}} href={parcel.publicTrackingUrl}
                              target="_blank" rel="noopener"
                        >
                            <Public/>
                            {t("parcel.link")}
                        </Link>
                    </Typography>

                </div>

                <EventsData currentPackage={currentPackage}/>

            </Paper>
        </Grid>
    </>)
}


export const EventsData: React.FC<{ currentPackage: ExternalPublicPackageDTO | undefined }> = ({currentPackage}) => {
    const {t} = useTranslation();

    return (<div>

        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{t("parcel.event.event")}</TableCell>
                        <TableCell>{t("parcel.event.date")}</TableCell>
                        <TableCell>{t("parcel.event.location")}</TableCell>
                        <TableCell>{t("parcel.event.desc")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentPackage?.events?.map((evt, index) => (
                        <TableRow key={index}>
                            <TableCell>{evt.eventName}</TableCell>
                            <TableCell>{evt.eventDate + " " + (evt.eventTime ? evt.eventTime.substring(0, 5) : "")}</TableCell>
                            <TableCell>{evt.location}</TableCell>
                            <TableCell>{evt.eventDescription}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </div>)
}


export const DimensionsData: React.FC<{ currentPackage: ExternalPublicPackageDTO | undefined }> = ({currentPackage}) => {
    return (<div>

        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Dessert (100g serving)</TableCell>
                        <TableCell align="right">Calories</TableCell>
                        <TableCell align="right">Fat&nbsp;(g)</TableCell>
                        <TableCell align="right">Carbs&nbsp;(g)</TableCell>
                        <TableCell align="right">Protein&nbsp;(g)</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {currentPackage?.dimensions?.map((dim, index) => (
                        <TableRow key={index}>
                            <TableCell>{dim.weight}</TableCell>
                            <TableCell>{dim.length}</TableCell>
                            <TableCell>{dim.width}</TableCell>
                            <TableCell>{dim.height}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </div>)
}


export default ParcelResultsComponents;
